import { formatShortScheduledLabel } from './eventPresentation';

const TERMINAL_EVENT_STATUSES = new Set(['CANCELLED', 'COMPLETED']);

function normalizeUpperString(value) {
  return typeof value === 'string' ? value.trim().toUpperCase() : '';
}

function normalizeDisplayString(value) {
  return typeof value === 'string' ? value.trim() : '';
}

export function isUpcomingScheduledEvent(event) {
  if (!event || typeof event !== 'object') return false;
  const status = normalizeUpperString(event.status);
  if (TERMINAL_EVENT_STATUSES.has(status)) return false;
  if (!event.startAt) return false;
  const startAt = new Date(event.startAt);
  return !Number.isNaN(startAt.getTime()) && startAt.getTime() >= Date.now();
}

function formatEventDatePart(startAt, timezone, options) {
  if (!startAt) return '';
  const date = new Date(startAt);
  if (Number.isNaN(date.getTime())) return '';
  try {
    return new Intl.DateTimeFormat(undefined, {
      ...options,
      timeZone: timezone || undefined,
    }).format(date);
  } catch (_err) {
    return '';
  }
}

function getEventStartTime(event) {
  const date = new Date(event?.startAt);
  return date.getTime();
}

export function buildScheduleEventRows(events, t = (key, opts) => opts?.defaultValue || key) {
  if (!Array.isArray(events)) return [];
  return events
    .filter(isUpcomingScheduledEvent)
    .sort((left, right) => getEventStartTime(left) - getEventStartTime(right))
    .map((event) => {
      const location = event.location || {};
      const venueName = event.venue?.name || location.locationName || null;
      const locationLabel = [location.city, location.stateOrRegion]
        .map((part) => (typeof part === 'string' ? part.trim() : ''))
        .filter(Boolean)
        .join(', ');
      const status = normalizeUpperString(event.status);
      const statusLabel = status && status !== 'PUBLISHED'
        ? t(`bandPage.schedule.status.${status.toLowerCase()}`, { defaultValue: status })
        : null;
      return {
        id: event.id,
        sourceEvent: event,
        day: formatEventDatePart(event.startAt, event.timezone, { day: '2-digit' }),
        month: formatEventDatePart(event.startAt, event.timezone, { month: 'short' }).toUpperCase(),
        title: event.title,
        subtitle: formatShortScheduledLabel(undefined, event.startAt, event.timezone),
        venue: venueName,
        location: locationLabel,
        description: normalizeDisplayString(event.description),
        pill: statusLabel,
        pillStatus: status === 'CANCELLED' ? 'sold' : 'default',
      };
    })
    .filter((event) => event.id && event.title);
}
